export class DistributionList {
    static $inject = ['name', 'global', 'stored'];
    constructor(name, global, stored) {
        this.name = name;
        this.global = global;
        this.stored = stored;
    }
    static createDistributionList(identity, application) {
        let name = identity.split('@')[0];
        let global = true;
        if (name && name.endsWith(`.${application.shortName}`)) {
            name = name.split('.')[0];
            global = false;
        }
        return new DistributionList(name, global, true);
    }
    static toIdentity(distributionList, application) {
        const name = `${distributionList.name
            .replace(/@/g, '')
            .replace(/\//g, '')
            .replace(/\./g, '')}`.trim();
        if (distributionList.global) {
            return `${name}@broadcast.msging.net`;
        }
        else {
            return `${name}.${application.shortName}@broadcast.msging.net`;
        }
    }
}
DistributionList.$inject = ['name', 'global', 'stored'];
